module.exports = __webpack_public_path__ + "img/txt.55cafea8.svg";